module.exports = __webpack_public_path__ + "static/media/app_home_navy.ef6ee7ce.svg";